import { getElColorPrimary } from '@/utils/theme-color'

export enum ServerStatus {
  normal = 1,
  abnormal,
  starting,
}

export enum ServerStatusLabel {
  normal = '正常',
  abnormal = '异常',
  starting = '启动中',
}

/** 非「正常」状态的固定色；「正常」请用 resolveServerStatusColor */
export enum ServerStatusColor {
  abnormal = '#E54545',
  starting = '#FB8F10',
}

/** 核心服务状态色（正常态随 dashboard 主题主色变化） */
export function resolveServerStatusColor (status: ServerStatus): string {
  if (status === ServerStatus.normal) {
    return getElColorPrimary()
  }
  const key = ServerStatus[status] as keyof typeof ServerStatusColor
  return ServerStatusColor[key] ?? getElColorPrimary()
}
